/* Mama's Daily product page, BUNDLE SIZES version (section: mdh-product-main-bundle).
   Separate copy of mdh-product.js so the live product page is untouched:
   - only runs on [data-mdh-pdp-bundle] (the live section uses [data-mdh-pdp])
   - its add-to-cart button is [data-mdh-bundle-atc], so md-pdp.js never binds to it
   - adds to cart itself, with one line item property per sub-pack size, then opens
     the Horizon cart drawer the same way md-pdp.js does. */
(function () {
  'use strict';
  if (window.__mdhProductBundleLoaded) return;
  window.__mdhProductBundleLoaded = true;

  function formatMoney(cents, format) {
    var fmt = format || '£{{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ---------------- Main product section ---------------- */
  function initProduct(root) {
    if (!root || root.dataset.mdhReady) return;
    root.dataset.mdhReady = 'true';
    var dataEl = root.querySelector('script[data-mdh-product]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var moneyFormat = data.moneyFormat;

    var slides = root.querySelector('.mdh-pdp__slides');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.mdh-pdp__thumb'));
    var countEl = root.querySelector('.mdh-pdp__count');
    var slideEls = slides ? Array.prototype.slice.call(slides.children) : [];

    function goTo(index) {
      if (!slides || !slideEls[index]) return;
      slides.scrollTo({ left: slideEls[index].offsetLeft, behavior: 'smooth' });
    }
    function currentIndex() {
      if (!slides || !slides.clientWidth) return 0;
      return Math.round(slides.scrollLeft / slides.clientWidth);
    }
    function syncGallery() {
      var i = currentIndex();
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      if (countEl) countEl.textContent = (i + 1) + ' / ' + slideEls.length;
    }
    if (slides) {
      var raf;
      slides.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncGallery); }, { passive: true });
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
      root.querySelectorAll('[data-mdh-gallery]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = currentIndex() + (btn.dataset.mdhGallery === 'next' ? 1 : -1);
          if (i < 0) i = slideEls.length - 1;
          if (i >= slideEls.length) i = 0;
          goTo(i);
        });
      });
    }

    var form = null;
    var addBtnEl = root.querySelector('[data-mdh-bundle-atc]');
    var idInput = { value: addBtnEl ? addBtnEl.dataset.variant : '' };
    var qtyInput = null;
    var addBtn = addBtnEl;
    var addLabel = root.querySelector('[data-mdh-add-label]');
    var nowEls = document.querySelectorAll('[data-mdh-now="' + data.sectionId + '"]');
    var wasEls = document.querySelectorAll('[data-mdh-was="' + data.sectionId + '"]');
    var pctEls = root.querySelectorAll('[data-mdh-pct]');
    var nameEls = document.querySelectorAll('[data-mdh-variant-name="' + data.sectionId + '"]');
    var sticky = document.querySelector('[data-mdh-sticky="' + data.sectionId + '"]');
    var addon = root.querySelector('.mdh-addon input');
    var itemsBox = root.querySelector('[data-mdh-items]');

    function selected() {
      var id = Number(idInput.value);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function syncItems() {
      if (!itemsBox) return;
      itemsBox.innerHTML = '';
      if (!addon || !addon.checked) return;
      var rows = [[idInput.value, qty()], [addon.value, 1]];
      rows.forEach(function (row, i) {
        ['id', 'quantity'].forEach(function (key, k) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[' + i + '][' + key + ']';
          input.value = row[k];
          itemsBox.appendChild(input);
        });
      });
    }

    /* ---- Bundle picker: pack cards, container-size tabs inside the selected one ---- */
    var bundle = data.bundle || null;
    var nameOverride = '';
    var bundleEl = root.querySelector('[data-mdb]');
    var saveText = bundleEl ? (bundleEl.dataset.saveText || '') : '';

    function resolveBundle() {
      var checked = root.querySelector('input[data-mdh-pack]:checked');
      if (!checked) return null;
      var card = checked.closest('[data-mdh-bpack]');
      var packVal = card.dataset.pack;
      root.querySelectorAll('[data-mdh-bpack]').forEach(function (c) { c.classList.toggle('is-on', c === card); });

      var sizeInput = card.querySelector('input[data-mdh-size]:checked');
      var size = sizeInput ? sizeInput.value : null;

      // Variant = pack + chosen size; falls back to the pack's first available variant
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.options || v.options[bundle.packIndex] !== packVal) continue;
        if (size !== null && v.options[bundle.sizeIndex] === size) { match = v; break; }
        if (!match || (!match.available && v.available)) match = v;
      }
      if (!match) return null;

      idInput.value = String(match.id);
      if (addBtnEl) { addBtnEl.dataset.variant = String(match.id); delete addBtnEl.dataset.properties; }
      nameOverride = (card.dataset.name || packVal) + (size ? ' · ' + size : '');

      // Every card shows the price for the size it would open on
      root.querySelectorAll('[data-mdh-bpack]').forEach(function (c) {
        if (c === card) { setCardPrice(c, match); return; }
        var cSize = c.querySelector('input[data-mdh-size]:checked');
        for (var k = 0; k < variants.length; k++) {
          var cv = variants[k];
          if (cv.options && cv.options[bundle.packIndex] === c.dataset.pack && (!cSize || cv.options[bundle.sizeIndex] === cSize.value)) { setCardPrice(c, cv); break; }
        }
      });
      return match;
    }

    function setCardPrice(card, v) {
      var priceEl = card.querySelector('[data-mdh-bpack-price]');
      if (!priceEl || !v) return;
      var b = priceEl.querySelector('b'), sEl = priceEl.querySelector('s'), em = priceEl.querySelector('em');
      var onSale = v.compare > v.price;
      if (b) b.textContent = formatMoney(v.price, moneyFormat);
      if (sEl) { sEl.hidden = !onSale; if (onSale) sEl.textContent = formatMoney(v.compare, moneyFormat); }
      if (em) {
        em.hidden = !onSale;
        if (onSale && saveText) {
          var pct = Math.round((v.compare - v.price) * 100 / v.compare);
          em.textContent = saveText.replace('[pct]', pct).replace('[amount]', formatMoney(v.compare - v.price, moneyFormat).replace(/\.00(?=\D*$)/, ''));
        }
      }
    }

    // Same size stays picked when switching packs
    function syncSize(fromInput) {
      var idx = fromInput.dataset.sizeIndex;
      root.querySelectorAll('[data-mdh-bpack]').forEach(function (c) {
        var twin = c.querySelector('input[data-mdh-size][data-size-index="' + idx + '"]');
        if (twin && twin !== fromInput && !twin.disabled) twin.checked = true;
      });
    }

    function onBundleChange() {
      var v = resolveBundle();
      if (!v) return;
      if (v.mediaIndex !== null && v.mediaIndex !== undefined) goTo(v.mediaIndex);
      if (data.updateUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      render();
    }

    function addonTotal() {
      var sum = 0;
      root.querySelectorAll('[data-md-addon-check]').forEach(function (cb) {
        if (cb.checked && !cb.disabled) sum += (Number(cb.dataset.price) || 0) * (Number(cb.dataset.qty) || 1);
      });
      return sum;
    }

    function render() {
      var v = selected();
      var q = qty();
      nowEls.forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      wasEls.forEach(function (el) {
        el.textContent = v.compare > v.price ? formatMoney(v.compare, moneyFormat) : '';
        el.hidden = !(v.compare > v.price);
      });
      pctEls.forEach(function (el) {
        var pct = v.compare > v.price ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
        el.hidden = !pct;
        var amount = formatMoney(Math.max(0, v.compare - v.price), moneyFormat).replace(/[.,]00(?=\D*$)/, '');
        el.textContent = (el.dataset.mdhPct || 'Save [pct]%').replace('[pct]', pct).replace('{pct}', pct).replace('[amount]', amount);
      });
      nameEls.forEach(function (el) { el.textContent = nameOverride || v.title; });
      var urg = root.querySelector('[data-mdh-urg]');
      if (urg) {
        var threshold = Number(urg.dataset.threshold) || 0, full = Number(urg.dataset.full) || 100, sold = Number(urg.dataset.sold) || 0;
        var left = typeof v.stock === 'number' ? v.stock : 0;
        var low = threshold > 0 && left > 0 && left <= threshold;
        var lowEl = urg.querySelector('[data-mdh-urg-low]'), bar = urg.querySelector('[data-mdh-urg-bar]');
        if (lowEl) { lowEl.hidden = !low; var n = lowEl.querySelector('[data-mdh-urg-left]'); if (n) n.textContent = left; }
        if (bar) { bar.hidden = !low; var pct = Math.min(100, Math.round((left * 100) / full)); if (low && pct < 3) pct = 3; bar.firstElementChild.style.width = pct + '%'; }
        urg.hidden = !(sold > 0 || low);
      }
      root.querySelectorAll('[data-mdh-hot]').forEach(function (hot) {
        if (hot.hasAttribute('data-mdh-hot-static')) return;
        var limit = Number(hot.dataset.threshold) || 0;
        var left = typeof v.stock === 'number' ? v.stock : 0;
        hot.hidden = !(limit > 0 && left > 0 && left <= limit);
        var c = hot.querySelector('[data-mdh-hot-left]');
        if (c) c.textContent = left;
      });
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) {
        addLabel.textContent = v.available
          ? data.addLabel + (data.showPriceInButton ? ', ' + formatMoney(v.price * q + addonTotal(), moneyFormat) : '')
          : data.soldOutLabel;
      }
      if (sticky) {
        var sb = sticky.querySelector('button');
        if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? data.addLabel : data.soldOutLabel; }
      }
      syncItems();
    }

    if (bundle) {
      root.querySelectorAll('input[data-mdh-pack]').forEach(function (radio) {
        radio.addEventListener('change', function () { if (radio.checked) onBundleChange(); });
      });
      root.querySelectorAll('input[data-mdh-size]').forEach(function (radio) {
        radio.addEventListener('change', function () { if (radio.checked) { syncSize(radio); onBundleChange(); } });
      });
    }

    if (!bundle) root.querySelectorAll('.mdh-pack input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        idInput.value = radio.value;
        if (addBtnEl) addBtnEl.dataset.variant = radio.value;
        var v = selected();
        if (v.mediaIndex !== null && v.mediaIndex !== undefined) goTo(v.mediaIndex);
        if (data.updateUrl && window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
        render();
      });
    });

    root.querySelectorAll('[data-mdh-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.mdhQty === 'plus' ? 1 : -1;
        qtyInput.value = Math.min(99, Math.max(1, qty() + step));
        render();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
    root.addEventListener('mdh:refresh', render);
    // Button price includes a ticked add-on
    root.querySelectorAll('[data-md-addon-check]').forEach(function (cb) { cb.addEventListener('change', render); });
    if (addon) addon.addEventListener('change', syncItems);

    if (form) form.addEventListener('submit', syncItems, true);

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var buy = root.querySelector('.mdh-pdp__buy');
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', String(!past));
      });
      io.observe(buy);
      var sbtn = sticky.querySelector('button');
      if (sbtn) sbtn.addEventListener('click', function () { addBtn.click(); });
    }

    if (addBtnEl) {
      addBtnEl.addEventListener('click', function (ev) {
        ev.preventDefault();
        var variantId = addBtnEl.dataset.variantOverride || addBtnEl.dataset.variant;
        if (!variantId) { window.location.href = '/cart'; return; }
        var line = { id: Number(variantId), quantity: 1 };
        if (addBtnEl.dataset.properties) {
          try {
            var props = JSON.parse(addBtnEl.dataset.properties);
            if (props && Object.keys(props).length) line.properties = props;
          } catch (e) {}
        }
        addToCart([line].concat(addonLines(root)), addBtnEl, root);
      });
    }

    if (bundle) resolveBundle();
    render();
    syncGallery();
  }

  /* ---------------- Add to cart (same flow as md-pdp.js, plus properties) ---------------- */
  function addonLines(root) {
    return Array.prototype.filter.call(root.querySelectorAll('[data-md-addon-check]'), function (cb) {
      return cb.checked && cb.dataset.variant;
    }).map(function (cb) { return { id: Number(cb.dataset.variant), quantity: Number(cb.dataset.qty) || 1 }; });
  }

  var _events;
  function getEvents() {
    if (_events !== undefined) return Promise.resolve(_events);
    return import('@shopify/events').then(function (m) { _events = m; return m; }, function () { _events = null; return null; });
  }

  async function addToCart(lines, btn, root) {
    if (!lines.length) return;
    // Only the label text changes while adding, so the button keeps its live label element
    var labelEl = btn ? btn.querySelector('[data-mdh-add-label]') : null;
    var original = btn && !labelEl ? btn.innerHTML : null;
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (labelEl) labelEl.textContent = 'Adding…'; else btn.innerHTML = 'Adding…';
    }
    var baseUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';
    var addUrl = baseUrl.replace(/\.js$/, '') + '.js';
    var totalQty = lines.reduce(function (n, l) { return n + (l.quantity || 1); }, 0);
    try {
      var ev = await getEvents();
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (i) { if (i.dataset.sectionId) ids.push(i.dataset.sectionId); });
      var payload = { items: lines };
      if (ids.length) payload.sections = ids.join(',');

      var deferred = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          deferred = ev.CartLinesUpdateEvent.createPromise();
          document.dispatchEvent(new ev.CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity }; }),
            promise: deferred.promise
          }));
        } catch (e) { deferred = null; }
      }

      var res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      });
      var data = await res.json();
      if (!res.ok || data.status) {
        if (deferred && deferred.reject) deferred.reject(new Error(data.message || 'add failed'));
        notify(data.description || data.message || 'Sorry, this could not be added to the cart.', true);
        return;
      }

      // Untick the add-on once it is in the cart, so a second click doesn't add it again
      var added = {};
      lines.forEach(function (l) { added[String(l.id)] = true; });
      root.querySelectorAll('[data-md-addon-check]').forEach(function (cb) {
        if (cb.checked && added[String(cb.dataset.variant)]) { cb.checked = false; cb.dispatchEvent(new Event('change')); }
      });

      if (deferred && deferred.resolve && ev.CartLinesUpdateEvent.createCartFromAjaxResponse) {
        try {
          var cart = await (await fetch('/cart.js')).json();
          deferred.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { didError: false, items: cart.items, source: 'mamas-daily', itemCount: totalQty },
            sections: data.sections
          });
        } catch (e) {
          try { deferred.resolve({ detail: { didError: false, itemCount: totalQty } }); } catch (_) {}
          await refreshDrawer();
        }
        openDrawer();
      } else {
        await refreshDrawer(); await refreshCount(); openDrawer();
      }
    } catch (e) {
      await refreshDrawer(); await refreshCount(); openDrawer();
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (original !== null) btn.innerHTML = original;
      }
      // Redraw label and price from the current selection
      root.dispatchEvent(new CustomEvent('mdh:refresh'));
    }
  }

  async function refreshDrawer() {
    try {
      var wrap = document.getElementById('shopify-section-cart-drawer-section');
      if (!wrap) return;
      var html = await (await fetch('/?section_id=cart-drawer-section')).text();
      if (html && html.trim()) wrap.innerHTML = html;
    } catch (e) {}
  }
  async function refreshCount() {
    try {
      var cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.cart-bubble, [data-cart-count], .cart-count').forEach(function (el) {
        el.textContent = cart.item_count; el.removeAttribute('hidden');
      });
    } catch (e) {}
  }
  function openDrawer() {
    var drawer = document.getElementById('cart-drawer');
    try { if (drawer && typeof drawer.open === 'function') { if (!drawer.isOpen) drawer.open(); return; } } catch (e) {}
    var trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
  }
  function notify(message, isError) {
    var el = document.getElementById('md-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'md-toast';
      el.className = 'mdp md-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('show');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('show'); }, 5000);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mdh-pdp-bundle]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();